import { Icon, Skeleton, Tooltip } from 'antd';
import * as React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { getCommentCount } from 'src/api/comments';
import { CommentApiPrefix } from 'src/api/routes';
import CommentIcon from 'src/components/common/icons/CommentIcon';
import ConversationCommentsDrawer from './ConversationCommentsDrawer';

const styles = (theme: any) => ({
  linkStyles: {
    display: 'flex',
    fontSize: '12px',
    fontWeight: 600,
    color: theme.colors.primary,
    cursor: 'pointer',
    marginBottom: '3px',
  },
});
interface CommentCountProps {
  classes: any;
  style: any;
  sourceObjectId: any;
  queryString: any;
  modalHeader: any;
  searchApi: any; // Required for invoicing, maybe need a better solution for this.
  commentApiPrefix: CommentApiPrefix;
  isLoading: boolean;
  prefetchedCount?: number;
}

const hasPrefetchedCount = (props: { prefetchedCount?: number | null }) =>
  typeof props.prefetchedCount === 'number';

const getCommentCountValue = (value: number | null | undefined) =>
  typeof value === 'number' ? value : 0;

class CommentCount extends React.PureComponent<CommentCountProps, any> {
  constructor(props) {
    super(props);
    const countFromProps = getCommentCountValue(this.props.prefetchedCount);
    this.state = {
      commentCount: countFromProps,
      isCommentCountLoaded: hasPrefetchedCount(props),
      viewCommentsModal: false,
    };
  }

  async componentDidMount() {
    if (hasPrefetchedCount(this.props)) {
      return;
    }
    await this.loadCommentCount();
  }

  async componentDidUpdate(prevProps: CommentCountProps) {
    const hasCurrentPrefetch = hasPrefetchedCount(this.props);
    const hadPrefetch = hasPrefetchedCount(prevProps);

    if (hasCurrentPrefetch) {
      if (!hadPrefetch || this.props.prefetchedCount !== prevProps.prefetchedCount) {
        this.setState({
          commentCount: getCommentCountValue(this.props.prefetchedCount),
          isCommentCountLoaded: true,
        });
      }
      return;
    }

    if (!hasCurrentPrefetch && hadPrefetch) {
      this.setState({
        commentCount: 0,
        isCommentCountLoaded: false,
      });
      await this.loadCommentCount();
      return;
    }

    if (this.props.isLoading && !prevProps.isLoading) {
      await this.loadCommentCount();
    }
  }

  loadCommentCount = async () => {
    this.setState({ isCommentCountLoaded: false });
    await this.fetchCommentCount();
    this.setState({ isCommentCountLoaded: true });
  }

  fetchCommentCount = async () => {
    const { sourceObjectId, commentApiPrefix } = this.props;
    const res = await getCommentCount(
      {
        sourceObjectId,
      },
      commentApiPrefix
    );
    if (res.isSuccess) {
      this.setState({ commentCount: getCommentCountValue(res.data) });
    }
  }

  setCommentsModalVisibility = (visible) => {
    this.setState({
      viewCommentsModal: visible,
    });
  }

  render () {
    const {
      classes,
      style,
      sourceObjectId,
      queryString,
      modalHeader,
      commentApiPrefix,
    } = this.props;
    const { commentCount, isCommentCountLoaded, viewCommentsModal } = this.state;

    return isCommentCountLoaded ?
    <span className={classes.linkStyles}
          style={style ? style : null}>
        <span style={{ verticalAlign: 'top' }}>
            {commentCount ? commentCount : '0'}
        </span>
        <Tooltip title="Comments">
          <CommentIcon style={{ marginLeft: '2px', fill: '#1890FF' }}
            onClick={() => {
              this.setCommentsModalVisibility(true);
            }} />
        </Tooltip>
        <ConversationCommentsDrawer
          commentApiPrefix={commentApiPrefix}
          searchApi={this.props.searchApi}
          header={<div style={{
            display: 'flex',
          }}>
            <Icon onClick={() => {
              this.setCommentsModalVisibility(false);
            }}
              style={{
                cursor: 'pointer',
                alignSelf: 'center',
              }} type="close" />
              {modalHeader}
          </div>}
          sourceObjectId={sourceObjectId}
          queryString={queryString}
          visible={viewCommentsModal}
          handleCancel={() => {
            this.setCommentsModalVisibility(false);
          }}/>
    </span>
    : <Skeleton active title={false} paragraph={{ rows: 1, width: '80px' }}/>;
  }
}

const CommentCountStyled = injectSheet(styles)(CommentCount);
export default withRouter(CommentCountStyled);
